// extracted by mini-css-extract-plugin
export default {"row":"Content_row__IGQ3F","label":"Content_label__uS8C4"};